/* eslint-disable */
import { lazy } from 'react';
import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';

const admin = {
  login: lazy(() => import('views/admin/Login')),
  dashboard: lazy(() => import('views/admin/Dashboard')),
  datingDashboard: lazy(() => import('views/admin/DatingDashboard')),
  users: lazy(() => import('views/admin/Users')),
  userDetailedView: lazy(() => import('views/admin/UserDetailedView')),
  register: lazy(() => import('views/admin/Register')),
  pendingUsers: lazy(() => import('views/admin/PendingUsers')),
  userManagement: lazy(() => import('views/admin/UserManagement')),
  admins: lazy(() => import('views/admin/Admins')),
  families: lazy(() => import('views/admin/Families')),
  providers: lazy(() => import('views/admin/Providers')),
  eventManagement: lazy(() => import('views/admin/events/EventManagement')),
  eventTickets: lazy(() => import('views/admin/events/EventTickets')),
};

const defaultPages = {
  login: lazy(() => import('views/default/Login')),
  register: lazy(() => import('views/admin/Register')),
};

const blog = lazy(() => import('views/blog/Blog'));
const community = {
  index: lazy(() => import('views/community/Community')),
  list: lazy(() => import('views/community/CommunityList')),
};
const upgrade = lazy(() => import('views/upgrade/Upgrade'));

const dashboard = {
  gettingStarted: lazy(() => import('views/dashboard/DashboardGettingStarted')),
  analysis: lazy(() => import('views/dashboard/DashboardAnalysis')),
};
const services = {
  database: lazy(() => import('views/services/ServicesDatabase')),
  databaseAdd: lazy(() => import('views/services/ServicesDatabaseAdd')),
  databaseDetail: lazy(() => import('views/services/ServicesDatabaseDetail')),
  storage: lazy(() => import('views/services/ServicesStorage')),
  storageFolder: lazy(() => import('views/services/ServicesStorageFolder')),
  hosting: lazy(() => import('views/services/ServicesHosting')),
  users: lazy(() => import('views/services/ServicesUsers')),
};
const account = {
  settings: lazy(() => import('views/account/AccountSettings')),
  billing: lazy(() => import('views/account/AccountBilling')),
  security: lazy(() => import('views/account/AccountSecurity')),
};
const support = {
  docs: lazy(() => import('views/support/SupportDocs')),
  docsDetail: lazy(() => import('views/support/SupportDocsDetail')),
  knowledgeBase: lazy(() => import('views/support/SupportKnowledgeBase')),
  tickets: lazy(() => import('views/support/SupportTickets')),
  ticketsDetail: lazy(() => import('views/support/SupportTicketsDetail')),
};

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/login`,
    },
    {
      path: `${appRoot}/login`,
      component: defaultPages.login,
      label: 'Login',
      hideInMenu: true,
    },
    {
      path: `${appRoot}/register`,
      component: defaultPages.register,
      label: 'Register',
      hideInMenu: true,
    },
    {
      path: `${appRoot}/admin/login`,
      component: admin.login,
      label: 'Admin Login',
      hideInMenu: true,
    },
    {
      path: `${appRoot}/blog`,
      component: blog,
      label: 'menu.blog',
      icon: 'file-text',
    },
    {
      path: `${appRoot}/upgrade`,
      label: 'menu.upgrade',
      icon: 'trend-up',
      component: upgrade,
    },
    {
      path: `${appRoot}/community`,
      label: 'menu.community',
      icon: 'messages',
      component: community.index,
      subs: [
        {
          path: '/list',
          label: 'menu.community-list',
          hideInMenu: true,
          component: community.list,
        },
      ],
    },
  ],
  sidebarItems: [
    {
      path: `${appRoot}/dashboard`,
      label: 'menu.dashboard',
      icon: 'home',
      exact: true,
      component: admin.datingDashboard,
      protected: true,
    },
    {
      path: `${appRoot}/user-management`,
      label: 'User Management',
      icon: 'user',
      exact: true,
      component: admin.userManagement,
      protected: true,
    },
    {
      path: `${appRoot}/admins`,
      label: 'Admins',
      icon: 'shield',
      exact: true,
      component: admin.admins,
      protected: true,
    },
    {
      path: `${appRoot}/providers`,
      label: 'Providers',
      icon: 'health',
      exact: true,
      component: admin.providers,
      protected: true,
    },
    {
      path: `${appRoot}/events`,
      label: 'Event Management',
      icon: 'calendar',
      exact: true,
      component: admin.eventManagement,
      protected: true,
      subs: [
        {
          path: '/:eventId/tickets',
          label: 'Tickets & Attendance',
          icon: 'file-text',
          component: admin.eventTickets,
          hideInMenu: true,
        },
      ],
    },
    {
      path: `${appRoot}/admin`,
      label: 'Admin',
      icon: 'shield',
      exact: true,
      redirect: true,
      to: `${appRoot}/admin/dashboard`,
      protected: true,
      hideInMenu: true,
      subs: [
        { path: '/dashboard', label: 'Dashboard', icon: 'grid-1', component: admin.datingDashboard, protected: true },
        { path: '/users-admin', label: 'Users Admin', icon: 'user', component: admin.users, protected: true },
        {
          path: '/users/:userId/detailed',
          label: 'User Detailed View',
          icon: 'file-text',
          component: admin.userDetailedView,
          protected: true,
          hideInMenu: true,
        },
      ],
    },
    {
      path: `${appRoot}/dashboard`,
      label: 'menu.dashboard',
      icon: 'grid-1',
      exact: true,
      redirect: true,
      to: `${appRoot}/dashboard/getting-started`,
      hideInMenu: true,
      subs: [
        { path: '/getting-started', label: 'menu.getting-started', icon: 'navigate-diagonal', component: dashboard.gettingStarted },
        { path: '/analysis', label: 'menu.analysis', icon: 'chart-4', component: dashboard.analysis },
      ],
    },
  ],
};
export default routesAndMenuItems;
